import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../components/BrandLogo';

const SignupMethod: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const signupMethods = [
    {
      id: 'email',
      icon: <EnvelopeIcon className="w-5 h-5" />,
      text: t('signup.continueWithEmail', 'Continue with email'),
      primary: true,
      action: () => navigate('/signup/email'),
    },
    {
      id: 'google',
      icon: (
        <svg className="w-5 h-5" viewBox="0 0 24 24">
          <path
            fill="#EA4335"
            d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
          />
        </svg>
      ),
      text: t('signup.continueWithGoogle', 'Continue with Google'),
      action: () => (window.location.href = '/api/auth/google'),
    },
  ];

  return (
    <div className="min-h-screen bg-dark-bg dark:bg-dark-bg bg-light-bg flex flex-col">
      <div className="mobile-container flex-1 flex flex-col">
        {/* Header */}
        <header className="flex items-center h-14 mt-safe">
          <button
            onClick={() => navigate(-1)}
            className="p-2 -ml-2 text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        </header>

        {/* Main content */}
        <div className="flex-1 flex flex-col px-6 pb-8">
          {/* Logo */}
          <div className="flex justify-center mb-8 mt-8">
            <BrandLogo
              imgClassName="h-14 w-auto"
              textClassName="text-3xl font-bold tracking-tight"
            />
          </div>

          {/* Title */}
          <h1 className="font-cormorant text-3xl font-bold text-dark-text dark:text-dark-text text-light-text text-center mb-2">
            {t('signup.chooseMethod', 'Choose how to sign up')}
          </h1>

          {/* Subtitle */}
          <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary text-center mb-8">
            {t('signup.pickMethod', 'Pick your preferred sign-up method')}
          </p>

          {/* Sign up methods */}
          <div className="space-y-3">
            {signupMethods.map((method) => (
              <button
                key={method.id}
                onClick={method.action}
                className={
                  method.primary
                    ? 'btn-primary flex items-center justify-center space-x-3'
                    : 'btn-secondary flex items-center justify-center space-x-3'
                }
              >
                {method.icon}
                <span>{method.text}</span>
              </button>
            ))}
          </div>

          {/* Sign in link */}
          <div className="text-center mt-6">
            <span className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary">
              {t('signup.alreadyHaveAccount', 'Already have an account?')}{' '}
            </span>
            <button
              onClick={() => navigate('/login')}
              className="text-primary-500 hover:text-primary-400 font-medium transition-colors"
            >
              {t('signup.signIn', 'Sign in')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupMethod;
